module.exports = __webpack_public_path__ + "img/todo.f60b35a7.svg";